import React, { useEffect } from "react";

import "./App.css";
import "./newLayout.css";
import { BrowserRouter } from "react-router-dom";
import Layout from "./components/Layout";
import { RecoilRoot } from "recoil";
import { useAuth } from "react-oidc-context";

function App() {
    const auth = useAuth();

    useEffect(() => {
        if (auth.isLoading) return;

        const currentPath = window.location.pathname;
        const isLoggedOutPath = currentPath === "/logged-out";

        if (!auth.isAuthenticated && !isLoggedOutPath) {
            auth.clearStaleState();

            auth.signinRedirect({
                state: {
                    returnUrl: currentPath + window.location.search,
                },
            });
        }
    }, [auth]);
    return (
        <RecoilRoot>
            <BrowserRouter>{!auth.isLoading && <Layout />}</BrowserRouter>
        </RecoilRoot>
    );
}

export default App;
